module.exports = __webpack_public_path__ + "media/images/default_icon-625c4bdcd7f6d0a5f79290cf9c2e5e5b.png";